(function () {
  function rootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function containsBlockedWords(text) {
    if (!text) return false;

    var blockedWords = [
      'fuck',
      'fucking',
      'fucker',
      'motherfucker',
      'shit',
      'bullshit',
      'cunt',
      'bitch',
      'bastard',
      'wanker',
      'prick',
      'twat',
      'arsehole',
      'asshole',
      'dickhead'
    ];

    var normalised = text
      .toLowerCase()
      .replace(/[@]/g, 'a')
      .replace(/[!1|]/g, 'i')
      .replace(/[$5]/g, 's')
      .replace(/[0]/g, 'o')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return blockedWords.some(function (word) {
      var pattern = new RegExp('\\b' + word + '\\b', 'i');
      return pattern.test(normalised);
    });
  }

  function setStatus(root, text) {
    var status = qs(root, '[data-gm-status]');

    if (status) {
      status.textContent = text || '';
    }
  }

  function fetchCart() {
    return fetch(rootUrl() + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart could not be read.');
      }

      return response.json();
    });
  }

  function getGiftLines(cart) {
    return cart.items
      .map(function (item, index) {
        return {
          item: item,
          line: index + 1
        };
      })
      .filter(function (entry) {
        return entry.item.properties && entry.item.properties['_Gift Card Product'] === 'true';
      });
  }

  function getPayload(root) {
    var selectedVariant = qs(root, '[data-gm-selected-variant-id]');
    var selectedCard = qs(root, '[data-gm-selected-card-title]');
    var selectedHandwritten = qs(root, '[data-gm-selected-handwritten]');
    var recipient = qs(root, '[data-gm-recipient]');
    var occasion = qs(root, '[data-gm-occasion]');
    var message = qs(root, '[data-gm-message]');
    var bottleVariantId = root.getAttribute('data-gm-bottle-variant-id') || '';
    var bottleQuantity = Number(root.getAttribute('data-gm-bottle-quantity') || '1');

    if (!bottleQuantity || bottleQuantity < 1) {
      bottleQuantity = 1;
    }

    return {
      variantId: selectedVariant ? selectedVariant.value.trim() : '',
      cardTitle: selectedCard ? selectedCard.value.trim() : '',
      handwritten: selectedHandwritten ? selectedHandwritten.value === 'true' : false,
      recipient: recipient ? recipient.value.trim() : '',
      occasion: occasion ? occasion.value.trim() : '',
      message: message ? message.value.trim() : '',
      bottleVariantId: bottleVariantId.trim(),
      bottleQuantity: bottleQuantity,
      sourceProductTitle: root.getAttribute('data-gm-source-product-title') || '',
      sourceProductHandle: root.getAttribute('data-gm-source-product-handle') || '',
      sourceProductUrl: root.getAttribute('data-gm-source-product-url') || ''
    };
  }

  function giftProperties(payload) {
    var properties = {
      '_Gift Card Product': 'true',
      'Message Style': payload.handwritten ? 'Handwritten' : 'Printed'
    };

    if (payload.cardTitle) {
      properties['Card Design'] = payload.cardTitle;
    }

    if (payload.recipient) {
      properties.Recipient = payload.recipient;
    }

    if (payload.occasion) {
      properties.Occasion = payload.occasion;
    }

    if (payload.message) {
      properties['Gift Message'] = payload.message;
    }

    if (payload.sourceProductTitle) {
      properties['_Gifted Product'] = payload.sourceProductTitle;
    }

    if (payload.sourceProductHandle) {
      properties['_Gifted Product Handle'] = payload.sourceProductHandle;
    }

    if (payload.sourceProductUrl) {
      properties['_Gifted Product URL'] = payload.sourceProductUrl;
    }

    return properties;
  }

  function addBottleAndGiftProduct(payload) {
    var items = [
      {
        id: Number(payload.bottleVariantId),
        quantity: payload.bottleQuantity
      },
      {
        id: Number(payload.variantId),
        quantity: 1,
        properties: giftProperties(payload)
      }
    ];

    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Bottle and gift message could not be added.');
      }

      return response.json();
    });
  }

  function changeCartLine(lineKey, quantity) {
    return fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Gift message could not be updated.');
      }

      return response.json();
    });
  }

  function removeGiftLines(giftLines) {
    return giftLines.reduce(function (promise, entry) {
      return promise.then(function () {
        return changeCartLine(entry.item.key, 0);
      });
    }, Promise.resolve());
  }

  function saveGiftBundle(payload) {
    return fetchCart().then(function (cart) {
      var giftLines = getGiftLines(cart);

      return removeGiftLines(giftLines).then(function () {
        return addBottleAndGiftProduct(payload);
      });
    });
  }

  function removeGiftProduct() {
    return fetchCart().then(function (cart) {
      var giftLines = getGiftLines(cart);
      return removeGiftLines(giftLines);
    });
  }

  function findSelectedOption(root) {
    var currentVariantInput = qs(root, '[data-gm-selected-variant-id]');
    var currentVariantId = currentVariantInput ? currentVariantInput.value : '';

    if (currentVariantId) {
      var optionById = qs(root, '[data-gm-card-option][data-gm-variant-id="' + currentVariantId + '"]');

      if (optionById) {
        return optionById;
      }
    }

    return qs(root, '[data-gm-card-option][aria-checked="true"]');
  }

  function updateBackImage(root, option) {
    if (!option) return;

    var preview = qs(root, '[data-gm-message-preview]');
    var previewInner = qs(root, '.gm-card-message-preview__inner');
    var previewImage = qs(root, '[data-gm-message-preview-image]');

    if (!preview || !previewInner || !previewImage) return;

    var backImage = option.getAttribute('data-gm-back-image');
    var backImageWidth = option.getAttribute('data-gm-back-image-width') || '1200';
    var backImageHeight = option.getAttribute('data-gm-back-image-height') || '900';
    var backAspect = option.getAttribute('data-gm-back-aspect') || backImageWidth + ' / ' + backImageHeight;

    previewInner.style.setProperty('--gm-card-back-aspect', backAspect);

    if (backImage) {
      preview.classList.add('gm-card-message-preview--has-image');
      previewInner.classList.add('gm-card-message-preview__inner--image');
      previewImage.hidden = false;
      previewImage.src = backImage;
      previewImage.width = backImageWidth;
      previewImage.height = backImageHeight;
    } else {
      preview.classList.remove('gm-card-message-preview--has-image');
      previewInner.classList.remove('gm-card-message-preview__inner--image');
      previewImage.hidden = true;
      previewImage.removeAttribute('src');
    }
  }

  function updateMessageStyle(root) {
    var selectedHandwritten = qs(root, '[data-gm-selected-handwritten]');
    var message = qs(root, '[data-gm-message]');

    if (!message) return;

    if (selectedHandwritten && selectedHandwritten.value === 'true') {
      message.classList.add('is-handwritten');
    } else {
      message.classList.remove('is-handwritten');
    }
  }

  function updatePreview(root, option) {
    updateMessageStyle(root);
    updateBackImage(root, option || findSelectedOption(root));
  }

  function chooseCard(root, card) {
    if (!card || card.getAttribute('aria-disabled') === 'true') return;

    qsa(root, '[data-gm-card-option]').forEach(function (other) {
      other.setAttribute('aria-checked', 'false');
    });

    card.setAttribute('aria-checked', 'true');

    var selectedVariant = qs(root, '[data-gm-selected-variant-id]');
    var selectedCard = qs(root, '[data-gm-selected-card-title]');
    var selectedHandwritten = qs(root, '[data-gm-selected-handwritten]');
    var previewImage = qs(root, '[data-gm-card-preview-image]');
    var previewUrl = card.getAttribute('data-gm-preview-image');
    var title = card.getAttribute('data-gm-card-title') || '';
    var handwritten = card.getAttribute('data-gm-handwritten') === 'true';

    if (selectedVariant) {
      selectedVariant.value = card.getAttribute('data-gm-variant-id') || '';
    }

    if (selectedCard) {
      selectedCard.value = title;
    }

    if (selectedHandwritten) {
      selectedHandwritten.value = handwritten ? 'true' : 'false';
    }

    if (previewImage && previewUrl) {
      previewImage.src = previewUrl;
      previewImage.alt = title || 'Selected card preview';
    }

    updatePreview(root, card);
  }

  function updateCardOnlyButtonState(root) {
    var cardOnly = qs(root, '[data-gm-card-only]');

    if (!cardOnly) return;

    var payload = getPayload(root);
    var hasMessage = Boolean(payload.message);

    cardOnly.disabled = hasMessage;

    if (hasMessage) {
      cardOnly.setAttribute('aria-disabled', 'true');
      cardOnly.setAttribute('title', 'Clear the message to include the card without a message.');
    } else {
      cardOnly.removeAttribute('aria-disabled');
      cardOnly.removeAttribute('title');
    }
  }

  function handleSave(root, button, cardOnlyMode) {
    var payload = getPayload(root);

    if (!payload.bottleVariantId) {
      setStatus(root, 'Please choose a bottle product in the section settings.');
      return;
    }

    if (!payload.variantId) {
      setStatus(root, 'Please choose a card.');
      return;
    }

    if (cardOnlyMode && payload.message) {
      setStatus(root, 'Clear the message first, or use Add gift message.');
      updateCardOnlyButtonState(root);
      return;
    }

    if (cardOnlyMode) {
      payload.message = '';
      payload.recipient = '';
      payload.occasion = '';
    }

    if (!cardOnlyMode && !payload.message) {
      setStatus(root, 'Please add a message, or choose Include card only.');
      return;
    }

    if (payload.message && containsBlockedWords(payload.message)) {
      setStatus(root, 'Please amend your message before saving. We are unable to include offensive language.');
      return;
    }

    button.disabled = true;
    setStatus(root, cardOnlyMode ? 'Adding bottle and card...' : 'Adding bottle and gift message...');

    saveGiftBundle(payload)
      .then(function () {
        var returnUrl = root.getAttribute('data-gm-return-url') || rootUrl() + 'cart';
        setStatus(root, cardOnlyMode ? 'Bottle and card added.' : 'Bottle and gift message added.');
        window.location.href = returnUrl;
      })
      .catch(function (error) {
        setStatus(root, error.message || 'Bottle and gift message could not be added.');
      })
      .finally(function () {
        button.disabled = false;
        updateCardOnlyButtonState(root);
      });
  }

  function initBanner(root) {
    if (root.__gmBannerInit) return;
    root.__gmBannerInit = true;

    var message = qs(root, '[data-gm-message]');
    var count = qs(root, '[data-gm-count]');
    var save = qs(root, '[data-gm-save]');
    var cardOnly = qs(root, '[data-gm-card-only]');
    var remove = qs(root, '[data-gm-remove]');

    if (message && count) {
      count.textContent = String(message.value.length);

      message.addEventListener('input', function () {
        count.textContent = String(message.value.length);
        updateCardOnlyButtonState(root);
      });
    }

    if (message && !count) {
      message.addEventListener('input', function () {
        updateCardOnlyButtonState(root);
      });
    }

    qsa(root, '[data-gm-card-option]').forEach(function (card) {
      card.addEventListener('click', function () {
        chooseCard(root, card);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          chooseCard(root, card);
        }
      });
    });

    if (save) {
      save.addEventListener('click', function () {
        handleSave(root, save, false);
      });
    }

    if (cardOnly) {
      cardOnly.addEventListener('click', function () {
        handleSave(root, cardOnly, true);
      });
    }

    if (remove) {
      remove.addEventListener('click', function () {
        remove.disabled = true;
        setStatus(root, 'Removing gift message...');

        removeGiftProduct()
          .then(function () {
            var returnUrl = root.getAttribute('data-gm-return-url') || rootUrl() + 'cart';
            window.location.href = returnUrl;
          })
          .catch(function (error) {
            setStatus(root, error.message || 'Gift message could not be removed.');
          })
          .finally(function () {
            remove.disabled = false;
          });
      });
    }

    updatePreview(root);
    updateCardOnlyButtonState(root);
  }

  function init() {
    qsa(document, '[data-gm-card-page]').forEach(initBanner);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  window.GiftMessageBanner = {
    init: init
  };
})();
